// extracted by mini-css-extract-plugin
module.exports = {"checkDiv":"_3PIGbidfmxsd13va9iaULb","checkLabel":"_7uSJMdvjApda-fWN9029y"};